import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import axios from 'axios'

// LayoutViews
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import FormLayout from '../components/Login/Layout/FormLayout.vue'
import SignUpLayout from '../components/SignUp/Layout/SignUpLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

// Admin pages
import Locations from '@/components/Dashboard/Views/Locations.vue'
import Analytics from '@/components/Dashboard/Views/Analytics.vue'
import Rewards from '@/components/Dashboard/Views/Rewards.vue'
import Profile from '@/components/Dashboard/Views/Profile.vue'
import RewardEditor from '@/components/Dashboard/Views/RewardEditor.vue'
import RewardsArchived from '@/components/Dashboard/Views/RewardsArchived'
import Support from '@/components/Dashboard/Views/Support.vue'

// Login pages
import Login from '@/components/Login/Views/Login.vue'
import PasswordReset from '@/components/Login/Views//PasswordReset/PasswordReset.vue'
import PasswordResetDone from '@/components/Login/Views/PasswordReset/PasswordResetDone.vue'
import PasswordResetConfirm from '@/components/Login/Views/PasswordReset/PasswordResetConfirm.vue'
import PasswordResetComplete from '@/components/Login/Views/PasswordReset/PasswordResetComplete.vue'

// Signup pages
import V1Billing from '@/components/Login/Views/StripeBilling/Billing.vue'
import Billing from '@/components/Dashboard/Views/Billing/Billing.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: 'locations',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('inspectToken');
      
      if (store.getters.isLoggedIn) {
        if (!store.getters.haveInitialData) {
          const payload = {
            headers: {
              Authorization: `JWT ${store.state.jwt.jwt}`
            } 
          }

          await axios.get(store.state.endpoints.initialData, payload)
            .then((response)=>{
              store.dispatch('parseUser', response.data);
              if (store.getters.user.should_request_billing_info && to.name !== 'Billing Success') {
                next('/billing')
              } else if (to.name === 'Locations' && store.getters.advertisers.length === 1) {
                next('/analytics');
              } else {
                next();
              }
            })
            .catch((error)=>{
              // eslint-disable-next-line
              console.log(error);
              next('/login');
            })
          } else {
            if (to.name === 'Locations' && store.getters.advertisers.length === 1) {
              next('/analytics');
            } else {
              next(); 
            }
          }
      } else {
        next('/login');
      }
    },
    children: [
      {
        path: 'locations',
        name: 'Locations',
        component: Locations,
        beforeEnter: (to, from, next) => {
          if (to.name === 'Locations' && store.getters.advertisers.length === 1) {
            next('/analytics');
          } else {
            next(); 
          }
        },
      },
      {
        path: 'analytics',
        name: 'Analytics',
        component: Analytics
      },
      {
        path: 'rewards',
        name: 'Rewards',
        component: Rewards
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'reward/edit',
        name: 'Reward Editor',
        component: RewardEditor
      },
      {
        path: 'reward/new',
        name: 'New Reward',
        component: RewardEditor
      },
      {
        path: 'rewards/archived',
        name: 'Archived Rewards',
        component: RewardsArchived
      },
      {
        path: 'support',
        name: 'Support',
        component: Support
      },
      {
        path: 'billing',
        name: 'Billing',
        component: Billing,
        beforeEnter (to, from, next) {
          if (!store.getters.user.should_request_billing_info) {
            next('analytics');
          } else {
            next();
          }
        }
      },
      {
        path: 'billing/success',
        name: 'Billing Success',
        beforeEnter (to, from, next) {
          if (to.query.session_id) {
            const headers = {
              headers: {
                Authorization: `JWT ${store.state.jwt.jwt}`,
                'Content-Type': 'application/json',
              }
            }

            const payload = JSON.stringify({
              session_id: to.query.session_id,
            })

            axios.post(store.state.endpoints.billingCompleteCheckoutSession, payload, headers);
            
            store.dispatch('updateUserShouldRequestBillingInfoFalse');
            next('/analytics');
            store.dispatch('setModalTitle', { title: 'Thank you!' })
            store.dispatch('setSVGType', { svg_type: 'checkmark' })
            store.dispatch('setModalMessage', { message: 'Card information saved...' })
            store.dispatch('setModalVisible', { visible: true })
            setTimeout(function () { 
              store.dispatch('setModalVisible', { visible: false })
            }, 2000)
          } else if (!store.getters.user.should_request_billing_info) {
            next('/analytics');
          } else {
            next();
          }
        },
      },
    ]
  },
  {
    path: '/',
    component: FormLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'password_reset',
        name: 'Password Reset',
        component: PasswordReset
      },
      {
        path: 'password_reset/done',
        name: 'Password Reset Done',
        component: PasswordResetDone
      },
      {
        path: 'reset/:uidb64/:token',
        name: 'Password Reset Confirm',
        component: PasswordResetConfirm
      },
      {
        path: 'reset/done',
        name: 'Password Reset Complete',
        component: PasswordResetComplete
      },
      {
        path: 'v1/billing',
        name: 'V1 Billing',
        component: V1Billing,
      },
    ]
  },
  {
    path: '/signup',
    component: SignUpLayout,
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes: routes
})